import React from 'react';
import { EnergyBar, HeroArt, PixelCoin } from './cartoon/Art';
import { buyLink } from './cartoon/links';
import { useCommerce } from '../commerce/CommerceContext';

export default function Hero() {
    // Checkout off: the purchase CTA goes to WhatsApp, like every other one on the page.
    const { enabled } = useCommerce();
    const purchase = enabled
        ? { href: '#bitbean' }
        : { href: buyLink, target: '_blank', rel: 'noopener noreferrer' };

    return (
        <section className="lc lc-section bg-violeta" id="inicio">
            <div className="lc-wrap lc-grid-2">
                <div>
                    <span className="lc-pill">café especial pra todos</span>
                    <h1 className="lc-title lc-title-xl">
                        Seu primeiro café especial começa aqui<span className="lc-dot">.</span>
                    </h1>
                    <p className="lc-text">
                        O BitBean é 100% arábica, vem do Cerrado Mineiro e tirou <b>82 pontos</b> na
                        avaliação de provadores. Tem notas de chocolate e caramelo, e é gostoso até sem açúcar.
                    </p>
                    <div className="lc-rule" />
                    <div className="lc-actions" style={{ marginTop: 0 }}>
                        <a {...purchase} className="lc-btn lc-btn-coin">
                            <PixelCoin /> Quero meu BitBean
                        </a>
                        <a href="#preparo" className="lc-btn-ghost">Como preparar em casa</a>
                    </div>
                    <div className="lc-chips">
                        <span className="lc-chip"><b>1.050 m</b> de altitude</span>
                        <span className="lc-chip">processo <b>natural</b></span>
                        <span className="lc-chip">torra <b>média</b></span>
                    </div>
                    <EnergyBar />
                </div>
                <div>
                    <HeroArt />
                </div>
            </div>
        </section>
    );
}
